<template>
  <div id="app">
    <div class="container">
      <div class="top text-center">
        <router-link to="/"><img src="./assets/logo_slogan_.png" class="logo"></router-link>
      </div>
    <router-view/>
    <Footer />
    </div>
  </div>
</template>

<script>
import Footer from '@/components/partials/Footer.vue'
export default {
  components: {
    Footer
  },
  name: 'App'
}
</script>

<style>
@import 'bootstrap/dist/css/bootstrap.min.css';
body, html, #app {
background: #f7f2e2;
}
.logo {
  width: 300px;
}
.card {
  background: #c7b5a5;
  color: #212b37;
}
a {
  color: #804850;
}
a:hover {
  color: #804850;
}

.btn-primary {
    color: #fffdf5;
    background-color: #7f4750;
    border-color: #70274b;
}

.btn-primary:hover {
      background-color: #a25061;
      border-color: #70274b;
}
</style>



// WEBPACK FOOTER //
// src/App.vue